// extracted by mini-css-extract-plugin
export default {"faq-card":"ProjectFaq_faq-card__CpmoE","btn-holder":"ProjectFaq_btn-holder__Izw35"};